export default __webpack_public_path__ + "static/weed-05ecafd1d4f26cfa262b09f1fac6c13e.jpg";